import type { TI_TextData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTITextData: Omit<TI_TextData, 'selectedVariable'> = {
  title: 'Default Text Title'
};
